module.exports = __webpack_public_path__ + "static/David-07b5e3ec57d32790fb598f3175a26688.jpg";